import React, { useEffect, useMemo, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import CrossfadeImage from "react-crossfade-image";

// hooks and utilities
import importAll from "common/importAll";

// styles
import "./Gallery.scoped.scss";

const screenshots = importAll(require.context("assets/images/screenshots", false, /^\.\/[^/]*\.png$/));

// function Gallery() {
// 	const [containerRef, setContainerRef] = useState(null);
// 	const [photoRef, setPhotoRef] = useState(null);
// 	const [buttonsEnabledState, setButtonsEnabledState] = useState([false, true]);
// 	const [selectedImage, setSelectedImage] = useState(null);

// 	const imageWidth = photoRef?.getBoundingClientRect().width || 0;

// 	const IMAGES_GAP = 30;
// 	const VIEWPORT_WIDTH = containerRef?.getBoundingClientRect().width || 0;
// 	const SCROLL_SPEED = VIEWPORT_WIDTH <= 500 ? 1 : Math.floor(VIEWPORT_WIDTH / (imageWidth + IMAGES_GAP));
// 	console.log(screenshots);

// 	function move(direction) {
// 		if (buttonsEnabledState[direction === -1 ? 0 : 1] === false) return;

// 		const containerWidth = containerRef.getBoundingClientRect().width;
// 		const currentScroll = containerRef.scrollLeft;
// 		const scroll = currentScroll + direction * SCROLL_SPEED * (imageWidth + IMAGES_GAP);
// 		containerRef.scrollTo({ left: scroll, behavior: "smooth" });

// 		const imagesFit = containerWidth / (imageWidth + IMAGES_GAP);
// 		const gapsFit = Math.ceil(imagesFit) - 1;
// 		const visibleWidth = imageWidth * imagesFit + IMAGES_GAP * gapsFit;

// 		const isAtTheEnd = scroll + visibleWidth >= containerRef.scrollWidth;
// 		const isAtTheBeginning = scroll <= 0;
// 		setButtonsEnabledState([!isAtTheBeginning, !isAtTheEnd]);
// 	}

// 	return (
// 		<div className="gallery">
// 			<i className={`fa-solid fa-chevron-left ${!buttonsEnabledState[0] && "disabled"}`} onClick={() => move(-1)}></i>

// 			<div className="photos" ref={setContainerRef}>
// 				{Object.values(screenshots).map((image, i) => (
// 					<div className={`img ${selectedImage === image ? "selected" : ""}`} key={i}>
// 						<img
// 							src={image}
// 							alt={`Screenshot ${i + 1}`}
// 							ref={i === 0 ? setPhotoRef : () => {}}
// 							onClick={() => setSelectedImage(image)}
// 						/>
// 					</div>
// 				))}
// 			</div>
// 			<i className={`fa-solid fa-chevron-right ${!buttonsEnabledState[1] && "disabled"}`} onClick={() => move(1)}></i>
// 		</div>
// 	);
// }

function Gallery() {
	const [selectedImage, setSelectedImage] = useState(0);
	const [galleryHeight, setGalleryHeight] = useState("100%");
	const s = useMemo(() => Object.values(screenshots), []);

	useEffect(() => {
		const mainImageRef = document.querySelector(".home .CrossfadeImage");
		if (window.innerWidth <= 960 || mainImageRef == null) return;

		const observer = new ResizeObserver(([img]) => {
			setGalleryHeight(img.borderBoxSize[0].blockSize + "px");
		});

		observer.observe(mainImageRef);
		return () => observer.unobserve(mainImageRef);
	}, []);

	return (
		<div className="gallery" style={{ height: galleryHeight }}>
			<CrossfadeImage src={s[selectedImage]} />
			<Scrollbars
				className="scroll_container"
				hideTracksWhenNotNeeded={true}
				renderTrackVertical={props => <div {...props} className="track_vertical" />}
				renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
				renderView={props => <div {...props} className="view" />}
				style={{ height: galleryHeight }}
			>
				<div className="image-list">
					{s.map((image, i) => (
						<img
							src={image}
							alt={`Screenshot ${i + 1}`}
							className={i === selectedImage ? "selected" : ""}
							onClick={() => setSelectedImage(i)}
							key={i}
						/>
					))}
				</div>
			</Scrollbars>
		</div>
	);
}

export default Gallery;
